// extracted by mini-css-extract-plugin
module.exports = {"article":"Article-module--article--2BjDv"};